import React, { useCallback } from 'react'

import styles from './VNPinPad.module.scss'
import VNSecureDots from './VNSecureDots'
import VNPinButton from './VNPinButton'
import VNSubmitButton from './VNSubmitButton'
import { ReactComponent as DeleteIcon } from '../../assets/icons/delete.svg'

/**
 * VNPinPad - Pin Screen Component for User/Manager Login Pin Entry
 *
 * @param {Object} props - The properties object.
 * @returns {JSX.Element} The rendered component.
 */
const VNPinPad = ({ onSetPin, onSubmit, pin = '', header = 'Enter Your Passcode', buttonText = 'Sign In' }) => {
  const pinMinLength = 1
  const pinMaxLength = 6
  const isValid = pin.length >= pinMinLength && pin.length <= pinMaxLength

  const onEntry = useCallback(
    (value) => {
      if (value === 'backspace') {
        onSetPin(pin.slice(0, -1))
        return
      }

      if (pin.length === pinMaxLength) return

      onSetPin(pin + value)
    },
    [onSetPin, pin],
  )

  return (
    <div className={styles.container}>
      <span className={styles.header}>{header}</span>
      <VNSecureDots count={pinMaxLength} subjectSize={pin.length} />
      <div className={styles.pinpad}>
        <VNPinButton onClick={onEntry} value="1" />
        <VNPinButton onClick={onEntry} value="2" />
        <VNPinButton onClick={onEntry} value="3" />
        <VNPinButton onClick={onEntry} value="4" />
        <VNPinButton onClick={onEntry} value="5" />
        <VNPinButton onClick={onEntry} value="6" />
        <VNPinButton onClick={onEntry} value="7" />
        <VNPinButton onClick={onEntry} value="8" />
        <VNPinButton onClick={onEntry} value="9" />
        <VNPinButton onClick={onEntry} value="0" className={styles.zeroButton} />
        <VNPinButton onClick={onEntry} value="backspace" renderChildern>
          <DeleteIcon className={styles.backspaceIcon} />
        </VNPinButton>
      </div>
      <VNSubmitButton disabled={!isValid} onClick={onSubmit} text={buttonText} />
    </div>
  )
}

export default VNPinPad
